<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :xl="6" :lg="8" :md="8" :sm="24">
            <a-form-item label="项目">
              <a-select
                style="max-width: 200px;min-width: 100%"
                showSearch
                :disabled="showable"
                placeholder="请选择"
                v-decorator="['projectId', {rules: [{required: true, message: '请选择项目'}]}]"
                :options="projectList"
                v-model="queryParam.projectId"
                optionFilterProp="children"
                allowClear
              >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="日期">
              <a-range-picker
                @change="onChange"
                v-model="clearDate"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="财务确认">
              <a-select v-model="queryParam.isAmount" placeholder="请选择" allowClear>
                <a-select-option value="0">未确认</a-select-option>
                <a-select-option value="1">已确认</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-button @click="() => {this.queryPage()}" type="primary">查询</a-button>
            <a-button @click="() => {queryParam = {},clearDate=undefined,queryParam.isSum=true}" style="margin-left: 8px">重置</a-button>
          </a-col>
        </a-row>
      </a-form>
      <div class="table-operator">
        <a-button type="primary" icon="download" @click="download" >Excel导出</a-button>
      </div>
    </div>
    <s-table
      :isInquire="false"
      bordered
      disabled="showable"
      ref="table"
      :data="loadData"
      :columns="columns"
      :rowKey="record => record.id"
    >
      <!--      <span slot="audit" slot-scope="text,record">-->
      <!--        <span v-if="String(text) === '1'">-->
      <!--          &lt;!&ndash;          <a-tag color="#108ee9">已确认</a-tag>&ndash;&gt;-->
      <!--          <span v-if="$auth('companyMechanicalCostVerification:audit')">-->
      <!--            <a-popconfirm title="是否确认修改" @confirm="audit(record)" okText="是" cancelText="否">-->
      <!--              <a-icon slot="icon" type="question-circle-o" style="color: red" />-->
      <!--              <a href="javascript:;">已确认</a>-->
      <!--            </a-popconfirm>-->
      <!--          </span>-->
      <!--          <span v-else>-->
      <!--            <a-tag color="#108ee9">已确认</a-tag>-->
      <!--          </span>-->
      <!--        </span>-->
      <!--        <span v-else>-->
      <!--          <span v-if="$auth('hireWorkerCostVerification:audit')">-->
      <!--            <a-popconfirm title="是否确认审计" @confirm="audit(record)" okText="是" cancelText="否">-->
      <!--              <a-icon slot="icon" type="question-circle-o" style="color: red" />-->
      <!--              <a href="javascript:;">未确认</a>-->
      <!--            </a-popconfirm>-->
      <!--          </span>-->
      <!--          <span v-else>-->
      <!--            <a-tag color="#f50">未确认</a-tag>-->
      <!--          </span>-->
      <!--        </span>-->
      <!--      </span>-->
      <span slot="isAmount" slot-scope="text,record">
        <span v-if="String(text) === '1'">
          <!--          <a-tag color="#108ee9">已确认</a-tag>-->
          <span v-if="$auth('hireWorkerCostVerification:isAmount')">
            <a-popconfirm title="是否确认修改" @confirm="isAmount(record)" okText="是" cancelText="否">
              <a-icon slot="icon" type="question-circle-o" style="color: red" />
              <a href="javascript:;">已确认</a>
            </a-popconfirm>
          </span>
          <span v-else>
            <a-tag color="#108ee9">已确认</a-tag>
          </span>
        </span>
        <span v-else>
          <span v-if="$auth('hireWorkerCostVerification:isAmount')">
            <a-popconfirm title="是否确认总金额" @confirm="isAmount(record)" okText="是" cancelText="否">
              <a-icon slot="icon" type="question-circle-o" style="color: red" />
              <a href="javascript:;">未确认</a>
            </a-popconfirm>
          </span>
          <span v-else>
            <a-tag color="#f50">未确认</a-tag>
          </span>
        </span>
      </span>
      <template slot="footer" style="float: right;">
        <span style="float: right; margin-right: 2%"><b>当前页合计费用金额：{{ totalAmount.toFixed(2) }} 元</b></span>
        <span style="float: right; margin-right: 5%"><b>总合计费用金额：{{ sumAmount.toFixed(2) }} 元</b></span>
        <br/>
      </template>
    </s-table>
  </a-card>
</template>
<script>
import moment from 'moment'
import { TableMixin } from '@/mixins/TableMixin'
import { fetchList, download, audit, isAmount } from '@/api/statement/hireWorkCost'
import { dropProjectList } from '@/api/project/ProjectInfo'
import { attendGroupList } from '@/api/common/AttendGroup'
import { dropSxWorkerTypeList } from '@/api/common/SxWorkerType'
import ACol from 'ant-design-vue/es/grid/Col'
export default {
  name: 'WorkerCost',
  components: { ACol },
  mixins: [TableMixin],
  data () {
    return {
      totalAmount: 0.00, // 当前页的金额总和
      sumAmount: 0.00, // 满足当前查询条件的所有金额总和
      projectList: [], // 项目
      groupList: [], // 考勤组
      workerTypeList: [], // 工人类别
      showable: false,
      clearDate: undefined,
      queryParam: {
        projectId: undefined,
        startTime: undefined,
        endTime: undefined,
        isSum: true, // 用于标识是否需要求和
        isAmount: undefined
      },
      purchaserQuery: {
        roleCode: 'sx_purchaser'
      },
      loadData: parameter => {
        return fetchList(
          Object.assign(parameter, this.queryParam)
        ).then(res => {
          this.sum(res.data)
          return res.data
        })
      },
      columns: [
        {
          title: '序号',
          width: '62px',
          customRender: (text, record, index) => {
            return (
              <div>
                {index + 1}
              </div>
            )
          }
        },
        {
          title: '队伍名称',
          width: '150px',
          dataIndex: 'teamName'
        },
        {
          title: '工作内容',
          dataIndex: 'content'
        },
        {
          title: '费用金额',
          width: '100px',
          dataIndex: 'totalPrice',
          customRender: (text) => {
            return (
              <div style="float:right">
                { text === null ? ' 0.00 ' : Number(text).toFixed(2)}
              </div>
            )
          }
        },
        {
          title: '日期',
          width: '120px',
          dataIndex: 'dailyDate',
          customRender: (text) => {
            return (
              <div>
                { moment(text).format('YYYY-MM-DD')}
              </div>
            )
          }
        },
        // {
        //   title: '审计',
        //   dataIndex: 'audit',
        //   width: '100px',
        //   scopedSlots: { customRender: 'audit' }
        // },
        {
          title: '确认总金额',
          width: '110px',
          dataIndex: 'isAmount',
          scopedSlots: { customRender: 'isAmount' }
        }
      ]
    }
  },
  methods: {
    sum (data) {
      this.totalAmount = 0.00
      this.sumAmount = data.sumAmount
      data.records.map(da => {
        if (da.totalPrice) {
          this.totalAmount += Number(da.totalPrice)
        }
      })
    },
    onChange (value, dateString) {
      this.queryParam.startTime = moment(dateString[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss')
      this.queryParam.endTime = moment(dateString[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss')
      if (this.queryParam.startTime === 'Invalid date') {
        this.queryParam.startTime = ''
        this.queryParam.endTime = ''
      }
    },
    init () {
      dropProjectList().then(res => {
        this.projectList = res.data
        this.queryParam.projectId = this.projectList[0].value
        this.queryPage()
      })
      attendGroupList().then(res => {
        this.groupList = res.data
      })
      dropSxWorkerTypeList().then(res => {
        this.workerTypeList = res.data
      })
    },
    download () {
      download(this.queryParam).then(res => {
        const blbo = new Blob([res], { type: 'application/vnd.ms-excel;charset=utf-8' })
        var link = document.createElement('a')
        link.href = window.URL.createObjectURL(blbo)
        link.download = '人工成本统计.xlsx'
        link.click()
      }).catch((e) => {
        this.$message.warning('下载失败')
      })
    },
    // 审计
    audit (record) {
      audit(record).then(res => {
        this.$message.success('操作成功')
        this.queryPage()
      }).catch(err => {
        this.$message.error(err.msg)
      })
    },
    isAmount (record) {
      isAmount(record).then(res => {
        this.$message.success('操作成功')
        this.queryPage()
      }).catch(err => {
        this.$message.error(err.msg)
      })
    }

  },
  created () {
    this.init()
  }
}
</script>
<style scoped>

</style>
